export default __webpack_public_path__ + "static/media/logo-codefi.7818a179.png";